// Copyright (c) 2022 by Move Closer

import { NavigationItem } from '../../../../contexts'

import { MegaMenuProps } from './MegaMenu.contracts'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const translateNavigationItemToMegaMenuProps = (navItem: NavigationItem): MegaMenuProps => {
  const additionalCategoryLink = {
    label: navItem.secondaryLabel || '',
    target: navItem.target
  }

  const additionalClass = navItem.additionalClass ?? ''
  const snippet = navItem.snippet

  return {
    navigations: navItem.children?.map((child) => {
      const subnavigation = child.children?.map((nestedChild) => {
        return {
          ...nestedChild,
          label: typeof nestedChild.label === 'undefined' ? '' : nestedChild.label.toString()
        }
      })

      return {
        header: {
          icon: child.icon,
          link: {
            ...child,
            label: typeof child.label === 'undefined' ? '' : child.label.toString()
          }
        },
        ...(subnavigation && subnavigation.length ? { children: subnavigation } : {})
      }
    }) ?? [],
    additionalCategoryLink,
    additionalClass,
    snippet
  }
}
